import {ChangeDetectionStrategy, Component, effect, ElementRef, Injectable, input, output, Signal, ViewChild} from "@angular/core";
import {KommentarId, OpprettKommentarSvarSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatError, MatFormField} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {TranslateModule} from "@ngx-translate/core";
import {MatButton, MatIconButton} from "@angular/material/button";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {map} from "rxjs/operators";
import {toSignal} from "@angular/core/rxjs-interop";
import {erIkkeTomStreng, erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {storStreng} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {lagrerSignal} from "felles-ng2/tjenester/LagrerIndikator";
import {MatIcon} from "@angular/material/icon";
import {TilpassAutosizeVedBreddeendringDirektiv} from "web-ng2/delt/direktiver/tilpassAutosizeVedBreddeendring/tilpassAutosizeVedBreddeendring";

const debug = initDebugger('NyttKommentarSvarKomponent');

@Component({
    selector: 'nytt-kommentar-svar',
    templateUrl: 'nytt-kommentar-svar.html',
    styleUrl: 'nytt-kommentar-svar.scss',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatError,
        MatInput,
        MatButton,
        CdkTextareaAutosize,
        TilpassAutosizeVedBreddeendringDirektiv,
        TranslateModule,
        StandardValideringsfeilPipe,
        VisSpinnerDirektiv,
        MatIconButton,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NyttKommentarSvarKomponent {

    @ViewChild('svarfelt') private svarfelt: ElementRef<HTMLTextAreaElement> | null = null;

    vedFulltSkjemaAktivert = output<boolean>();

    traadId = input.required<KommentarId>();

    skjema = new FormControl('', {nonNullable: true, validators: storStreng});

    visFulltSkjema!: Signal<boolean>;
    lagrer = lagrerSignal();

    constructor(private avhengigheter: NyttKommentarSvarKomponentAvhengigheter) {
        //aktiver fullt skjem når kommentarfelt inneholder tekst
        this.visFulltSkjema = toSignal(this.skjema.valueChanges
          .pipe(map(kommentar => erIkkeTomStreng(kommentar))), {initialValue: false});

        //informer kaller om at fullt skjema er aktivert/deaktivert
        effect(() => {
            this.vedFulltSkjemaAktivert.emit(this.visFulltSkjema())
        });
    }

    async registrer() {
        //vi har ikke definert svar som required (for å unngå at skjema vises rødmerket når det ikke er i bruk)
        if (erTomEllerNil(this.skjema.value)) return;

        await this.lagrer.utfør(async () => {
            await this.avhengigheter.registrerSvar(this.traadId(), {svar: this.skjema.value});
            this.nullstillSkjema();
        });
    }

    avbryt() {
        this.nullstillSkjema();
    }

    giFokus() {
        this.svarfelt?.nativeElement.focus();
    }

    //private hjelpemetoder

    private nullstillSkjema() {
        this.skjema.setValue('');
    }
}

@Injectable()
export class NyttKommentarSvarKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    async registrerSvar(id: KommentarId, spesifikasjon: OpprettKommentarSvarSpesifikasjon): Promise<void> {
        await this.kommentarDatatjeneste.opprettKommentarSvar(id, spesifikasjon);
    }
}
